import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import ProjectList from "./pages/Projects/ProjectList";
import Dashboard from "./pages/Dashboard/Dashboard";
import Configs from "./pages/Projects/Configurations/Configs";
import Properties from "./pages/Properties/Properties";
import AgentList from "./pages/Agents/AgentList";
import RolesDashboard from "./pages/RoleManagement/RolesDashboard";
import CustomerDashboard from "./pages/Customers/CustomerDashboard";
import SalesDashboard from "./pages/Sales/SalesDashboard";
import Settings from "./pages/Settings/Settings";
import Sidebar from "./components/Sidebar";
import NavBar from "./components/NavBar";
import ProjectDetails from "./pages/Projects/ProjectDetails";
import { ProjectProvider } from "./context/ProjectContext";
import UserPage from "./pages/Customers/UserPage";
import ConfigDetails from "./components/ProjectScreens/ConfigDetails";
import LoginPage from "./pages/Login/LoginPage";
import InteriorDesignerSignup from "./pages/Login/InteriorDesignerSignup";
// Work marketplace — Architect (Party A) + Freelancer (Party B) + admin
import ArchitectSignup from "./pages/Login/ArchitectSignup";
import FreelancerSignup from "./pages/Login/FreelancerSignup";
import ArchitectDashboard from "./pages/Architect/ArchitectDashboard";
import ArchitectNewProject from "./pages/Architect/NewProject";
import ArchitectProjectDetail from "./pages/Architect/ArchitectProjectDetail";
import ArchitectWallet from "./pages/Architect/ArchitectWallet";
import ArchitectProfile from "./pages/Architect/ArchitectProfile";
import FreelancerDashboard from "./pages/Freelancer/FreelancerDashboard";
import FreelancerSkills from "./pages/Freelancer/FreelancerSkills";
import FreelancerAssignedProject from "./pages/Freelancer/FreelancerAssignedProject";
import FreelancerProfile from "./pages/Freelancer/FreelancerProfile";
import MarketplaceAdmin from "./pages/ZumaleAdmin/MarketplaceAdmin";
import ChannelPartnerSignup from "./pages/Login/ChannelPartnerSignup";
import SubscriptionsInfoPage from "./pages/Subscriptions/SubscriptionsInfoPage";
import { UserProvider, useUser } from "./context/UserContext";
import PrivateRoute from "./utils/PrivateRoute";
import Unauthorized from "./components/Unauthorized";
import AgentDashboard from "./pages/AgentView/AgentDashboard";
import UserDashboard from "./pages/UserView/UserDashboard";
import CreateProject from "./pages/Projects/CreateProject";
import PropertyUserView from "./pages/UserView/PropertyUserView";
import Profile from "./pages/Profile/Profile";
import { SalesProvider } from "./context/SalesContext";
import SoldPropertyDetails from "./pages/Properties/SoldPropertyDetails";
import CustomerList from "./pages/ZumaleUser/CustomerList";
import ZumaleAdminDashboard from "./pages/ZumaleAdmin/ZumaleAdminDashboard";
import ZumaleAdminReports from "./pages/ZumaleAdmin/ZumaleAdminReports";
import InteriorExecutions from "./pages/ZumaleAdmin/InteriorExecutions";
import InteriorExecutionDetailAdmin from "./pages/ZumaleAdmin/InteriorExecutionDetailAdmin";
import InteractionDetailReadOnly from "./pages/ZumaleAdmin/InteractionDetailReadOnly";
import ZumaleSettings from "./pages/ZumaleAdmin/ZumaleSettings";
import MaterialVendors from "./pages/ZumaleAdmin/MaterialVendors";
import ReferralVendors from "./pages/ZumaleAdmin/ReferralVendors";
import ReferralRewards from "./pages/ZumaleAdmin/ReferralRewards";
import ReferralRedemptions from "./pages/ZumaleAdmin/ReferralRedemptions";
import Referrals from "./pages/ZumaleAdmin/Referrals";
import TenderQuotePage from "./pages/Public/TenderQuotePage";
import AgreementTemplate from "./pages/ZumaleAdmin/AgreementTemplate";
import Requests from "./pages/ZumaleAdmin/Requests";
import Team from "./pages/ZumaleAdmin/Team";
import AdminProjects from "./pages/ZumaleAdmin/AdminProjects";
import InternalOwners from "./pages/ZumaleAdmin/InternalOwners";
import ReferralCommissions from "./pages/AgentView/ReferralCommissions";
import AdminProjectDetail from "./pages/ZumaleAdmin/AdminProjectDetail";
import Reports from "./pages/Reports/Reports";
import PerformanceDashBoard from "./pages/Reports/Performance/PerformanceDashboard";
import SalesReport from "./pages/Reports/SalesReport";
import CompletionReport from "./pages/Reports/CompletionReport";
import ViewCustomer from "./pages/ZumaleUser/ViewCustomer";
import Footer from "./components/Footer";
import Communications from "./pages/Communications/Communications";
import Advertisements from "./pages/Advertisements/Advertisements";
import Template from "./pages/Communications/Whatsapp/Template";
import WhatsAppSetup from "./pages/WhatsAppSetup/WhatsAppSetup";


import Approval from "./pages/Approval/Approval";
import Workflow from "./pages/Communications/Whatsapp/Workflow";
import CreateWorkflow from "./pages/Communications/Whatsapp/CreateWorkflow";
import SiteVisit from "./pages/SiteVisit";
import PhaseDetails from "./pages/Projects/PhaseDetails";
import InteriorDesignerDashboard from "./pages/InteriorDesigner/InteriorDesignerDashboard";
import Phases from "./pages/InteriorDesigner/Phases";
import InteriorDesignerPhaseDetails from "./pages/InteriorDesigner/PhaseDetails";
import InteriorDesignerConfigDetails from "./pages/InteriorDesigner/ConfigDetails";
import Leads from "./pages/InteriorDesigner/Leads";
import LeadRequestDetails from "./pages/InteriorDesigner/LeadRequestDetails";
import Designs from "./pages/InteriorDesigner/Designs";
import InteriorDesignerSettings from "./pages/InteriorDesigner/InteriorDesignerSettings";
import AddPortfolio from "./pages/InteriorDesigner/AddPortfolio";
import AddPortfolioBoq from "./pages/InteriorDesigner/AddPortfolioBoq";
import BVPhaseList from "./pages/BV_user/BV_PhaseList";
import BV_PhaseDetails from "./pages/BV_user/BV_PhaseDetails";
import BV_ConfigDetails from "./pages/BV_user/BV_ConfigDetails";
import BuyerDetails from "./pages/BV_user/BuyerDetails";
import Buyers from "./pages/BV_user/Buyers";
import RequestDetails from "./pages/BV_user/RequestDetails";
import ExecutionUnits from "./pages/BV_user/ExecutionUnits";
import ExecutionUnitDetail from "./pages/BV_user/ExecutionUnitDetail";
import InteriorDesigners from "./pages/ZumaleAdmin/InteriorDesigners";
// F18 (v2): Interior execution routes
import UnitExecutionDashboard from "./pages/Projects/UnitExecutionDashboard";
import ExecutionPlannerScreen from "./pages/Projects/ExecutionPlannerScreen";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  return (
    <UserProvider>
      <SalesProvider>
        <Router>
          <div className="min-h-screen bg-gray-100 flex flex-col">
            <AppRoutes
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          </div>
        </Router>
      </SalesProvider>
    </UserProvider>
  );
}

function AppRoutes({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const { userInfo } = useUser();

  // Standalone, token-gated vendor tender-quote page — renders with no app chrome and
  // regardless of auth (vendors open it from an emailed magic link without logging in).
  if (location.pathname.startsWith("/tender/")) {
    return (
      <Routes>
        <Route path="/tender/:token" element={<TenderQuotePage />} />
      </Routes>
    );
  }

  // Gate the public/unauthenticated route set on whether we have an active persona.
  const persona = userInfo?.persona;

  if (!persona) {
    return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup/interior-designer" element={<InteriorDesignerSignup />} />
        <Route path="/signup/architect" element={<ArchitectSignup />} />
        <Route path="/signup/freelancer" element={<FreelancerSignup />} />
        <Route path="/signup/channel-partner" element={<ChannelPartnerSignup />} />
        <Route path="/subscriptions" element={<SubscriptionsInfoPage />} />
        <Route path="/site-visit" element={<SiteVisit />} />

      </Routes>
    );
  }

  const isLoginOrRegisterPage =
    location.pathname === "/" ||
    location.pathname === "/subscriptions" ||
    location.pathname === "/site-visit";

  return (
    // <ProjectProvider>
    <>
      <div className="flex flex-col min-h-screen bg-gray-100 page-container">
        {!isLoginOrRegisterPage && <NavBar toggleSidebar={toggleSidebar} />}

        {/* Sidebar */}
        {!isLoginOrRegisterPage && (
          <Sidebar
            isOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            className={`fixed top-0 left-0 z-50 h-full bg-white transition-transform duration-300 ${isSidebarOpen ? "translate-x-0 w-64" : "-translate-x-64 w-0"
              } sm:translate-x-0 sm:w-64`}
          />
        )}

        {/* Dark Overlay (only over content area, excluding sidebar) */}
        {isSidebarOpen && !isLoginOrRegisterPage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 sm:ml-64 ml-0"
            onClick={toggleSidebar} // Close the sidebar when clicking on the overlay
          />
        )}

        {/* Content
            `flex-grow` fills the vertical space between NavBar and Footer so
            the Footer sits flush at the bottom of the viewport (no manual
            spacer needed). The inner wrapper caps the page width at 1536px
            and centres it on wide monitors — prevents the edge-to-edge
            sprawl that happens on 24"+ screens. */}
        <div
          className={`flex-grow p-8 pt-20 transition-all duration-300 pl-8 sm:pl-16 content-area ${isSidebarOpen && !isLoginOrRegisterPage ? "pl-64 " : "pl-0"
            }`}
        >
         <div className="w-full max-w-screen-2xl mx-auto">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup/interior-designer" element={<InteriorDesignerSignup />} />
            <Route path="/signup/architect" element={<ArchitectSignup />} />
            <Route path="/signup/freelancer" element={<FreelancerSignup />} />
            <Route path="/signup/channel-partner" element={<ChannelPartnerSignup />} />
            <Route path="/subscriptions" element={<SubscriptionsInfoPage />} />
            <Route path="/site-visit" element={<SiteVisit />} />

            {/* Work marketplace — Architect (Party A) */}
            <Route
              path="/architect/dashboard"
              element={<PrivateRoute allowedRoles={["ARCHITECT"]}><ArchitectDashboard /></PrivateRoute>}
            />
            <Route
              path="/architect/projects/new"
              element={<PrivateRoute allowedRoles={["ARCHITECT"]}><ArchitectNewProject /></PrivateRoute>}
            />
            <Route
              path="/architect/projects/:projectId"
              element={<PrivateRoute allowedRoles={["ARCHITECT"]}><ArchitectProjectDetail /></PrivateRoute>}
            />
            <Route
              path="/architect/wallet"
              element={<PrivateRoute allowedRoles={["ARCHITECT"]}><ArchitectWallet /></PrivateRoute>}
            />
            <Route
              path="/architect/profile"
              element={<PrivateRoute allowedRoles={["ARCHITECT"]}><ArchitectProfile /></PrivateRoute>}
            />

            {/* Work marketplace — Freelancer (Party B) */}
            <Route
              path="/freelancer/dashboard"
              element={<PrivateRoute allowedRoles={["FREELANCER"]}><FreelancerDashboard /></PrivateRoute>}
            />
            <Route
              path="/freelancer/skills"
              element={<PrivateRoute allowedRoles={["FREELANCER"]}><FreelancerSkills /></PrivateRoute>}
            />
            <Route
              path="/freelancer/projects/:projectId"
              element={<PrivateRoute allowedRoles={["FREELANCER"]}><FreelancerAssignedProject /></PrivateRoute>}
            />
            <Route
              path="/freelancer/profile"
              element={<PrivateRoute allowedRoles={["FREELANCER"]}><FreelancerProfile /></PrivateRoute>}
            />

            {/* Work marketplace — Zumale admin */}
            <Route
              path="/zumale-admin/marketplace"
              element={<PrivateRoute allowedRoles={["ZUMALE_USER"]}><MarketplaceAdmin /></PrivateRoute>}
            />

            <Route
              path="/profile"
              element={
                <PrivateRoute
                  allowedRoles={[
                    "ADMIN",
                    "ZUMALE_USER",
                    "USER",
                    "AGENT",
                    "SALES",
                    "DEVELOPER",
                    "INTERIOR_DESIGNER",
                    "BV_USER",
                  ]}
                >
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/properties/sold/:customerSaleId"
              element={
                <PrivateRoute
                  allowedRoles={["ADMIN", "SALES", "AGENT", "DEVELOPER"]}
                >
                  <SoldPropertyDetails />
                </PrivateRoute>
              }
            />

            {/* <Route path="/developer-dashboard" element={<PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}><Dashboard /></PrivateRoute>} /> */}
            <Route
              path="/admin-dashboard"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <PrivateRoute
                  allowedRoles={["ADMIN", "SALES", "AGENT", "DEVELOPER"]}
                >
                  <ProjectList />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-project"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                  <CreateProject />
                </PrivateRoute>
              }
            />
            <Route
              path="/project-details/:projectId"
              element={
                <ProjectProvider>
                  <PrivateRoute
                    allowedRoles={[
                      "USER",
                      "ADMIN",
                      "AGENT",
                      "SALES",
                      "DEVELOPER",
                      "PRESALES_SALES",
                    ]}
                  >
                    <ProjectDetails />
                  </PrivateRoute>
                </ProjectProvider>
              }
            />
            <Route
              path="/agents"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "SALES", "DEVELOPER"]}>
                  <AgentList />
                </PrivateRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects/configurations"
              element={
                <PrivateRoute
                  allowedRoles={["ADMIN", "SALES", "AGENT", "DEVELOPER", "PRESALES_SALES"]}
                >
                  <Configs />
                </PrivateRoute>
              }
            />
            <Route
              path="/properties"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "SALES", "DEVELOPER", "PRESALES", "PRESALES_SALES"]}>
                  <Properties />
                </PrivateRoute>
              }
            />

            {/* <Route path="/projects/notifications" element={<PrivateRoute allowedRoles={["SALES", "ADMIN", "DEVELOPER"]}><Notifications /></PrivateRoute>} /> */}
            <Route path="/communications" element={<PrivateRoute allowedRoles={["SALES", "ADMIN", "DEVELOPER", "PRESALES", "PRESALES_SALES"]}><Communications /></PrivateRoute>} />
            <Route path="/advertisements" element={<PrivateRoute allowedRoles={["SALES", "ADMIN", "DEVELOPER"]}><Advertisements /></PrivateRoute>} />
            <Route path="/leads" element={<Workflow />} />
            <Route path="/template/:templateType" element={<Template />} />
            <Route path="/workflow/:leadType" element={<CreateWorkflow />} />
            <Route
              path="/projects/:projectId/configs/:configId"
              element={
                <PrivateRoute
                  allowedRoles={["SALES", "ADMIN", "AGENT", "DEVELOPER"]}
                >
                  <ConfigDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/role-management"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                  <RolesDashboard />
                </PrivateRoute>
              }
            />
            {/* /manage-roles moved into Settings → Role Based Access (see Profile.jsx).
                Redirect any old links into the Settings tab. */}
            <Route path="/manage-roles" element={<Navigate to="/profile#rbac" replace />} />
            <Route
              path="/customers"
              element={
                <PrivateRoute
                  allowedRoles={["ADMIN", "SALES", "AGENT", "DEVELOPER", "PRESALES", "PRESALES_SALES"]}
                >
                  <CustomerDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/user-details/:id"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "SALES", "DEVELOPER"]}>
                  <UserPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "SALES", "DEVELOPER", "PRESALES_SALES"]}>
                  <SalesDashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/agent-dashboard"
              element={
                <PrivateRoute allowedRoles={["AGENT"]}>
                  <AgentDashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/referral-commissions"
              element={
                <PrivateRoute allowedRoles={["AGENT"]}>
                  <ReferralCommissions />
                </PrivateRoute>
              }
            />

            <Route
              path="/sales-dashboard"
              element={
                <PrivateRoute allowedRoles={["SALES"]}>
                  <SalesDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/presales-dashboard"
              element={
                <PrivateRoute allowedRoles={["PRESALES"]}>
                  <SalesDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/presales-sales-dashboard"
              element={
                <PrivateRoute allowedRoles={["PRESALES_SALES"]}>
                  <SalesDashboard />
                </PrivateRoute>
              }
            />


            <Route
              path="/user-dashboard"
              element={
                <PrivateRoute allowedRoles={["USER"]}>
                  <UserDashboard />
                </PrivateRoute>
              }
            />
            {/* <Route path="/user-agreements" element={<PrivateRoute allowedRoles={["USER"]}><AgreementApprov /></PrivateRoute>} /> */}
            <Route
              path="/user-property"
              element={
                <PrivateRoute allowedRoles={["USER"]}>
                  <PropertyUserView />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin-dashboard"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ZumaleAdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/settings"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ZumaleSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/agreements"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <AgreementTemplate />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/requests"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <Requests />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/team"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <Team />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/projects"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <AdminProjects />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/internal-owners"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <InternalOwners />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/projects/:projectId"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <AdminProjectDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/reports"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ZumaleAdminReports />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/interior-executions"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <InteriorExecutions />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/interior-executions/interactions/:leadId"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <InteractionDetailReadOnly />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/interior-executions/:leadId"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <InteriorExecutionDetailAdmin />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/material-vendors"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <MaterialVendors />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/referral-vendors"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ReferralVendors />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/referral-rewards"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ReferralRewards />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/referral-redemptions"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ReferralRedemptions />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/referrals"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <Referrals />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale-admin/interior-designers"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <InteriorDesigners />
                </PrivateRoute>
              }
            />
            <Route
              path="/zumale_user-dashboard"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <CustomerList />
                </PrivateRoute>
              }
            />
            {/* Reports — single sidebar entry; nested vertical nav lives inside
                the Reports layout. Sub-routes are children so URLs like
                /reports/sales still deep-link directly. */}
            <Route
              path="/reports"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "SALES", "PRESALES_SALES"]}>
                  <Reports />
                </PrivateRoute>
              }
            >
              <Route path="sales" element={<SalesReport />} />
              <Route path="performance" element={<PerformanceDashBoard />} />
              <Route path="completion" element={<CompletionReport />} />
            </Route>
            <Route
              path="/project-details/:projectId"
              element={
                <ProjectProvider>
                  <PrivateRoute
                    allowedRoles={[
                      "USER",
                      "ADMIN",
                      "AGENT",
                      "SALES",
                      "DEVELOPER",
                    ]}
                  >
                    <ProjectDetails />
                  </PrivateRoute>
                </ProjectProvider>
              }
            />
            <Route
              path="/project-details/:projectId/phase/:phaseId"
              element={
                <ProjectProvider>
                  <PrivateRoute
                    allowedRoles={[
                      "USER",
                      "ADMIN",
                      "AGENT",
                      "SALES",
                      "DEVELOPER",
                    ]}
                  >
                    <PhaseDetails />
                  </PrivateRoute>
                </ProjectProvider>
              }
            />
            {/* F18 (v2): Interior execution engine routes */}
            <Route
              path="/unit-execution/:propertyId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "SALES"]}>
                  <UnitExecutionDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects/execution-planner/:phaseId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                  <ExecutionPlannerScreen />
                </PrivateRoute>
              }
            />

            <Route
              path="/customers/view/:customerId"
              element={
                <PrivateRoute allowedRoles={["ZUMALE_USER"]}>
                  <ViewCustomer />
                </PrivateRoute>
              }
            />
            <Route path="/approvals" element={
              <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "SALES"]}>
                <Approval />
              </PrivateRoute>
            }
            />
            <Route path="/whatsapp/setup" element={
              <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER"]}>
                <WhatsAppSetup />
              </PrivateRoute>
            }
            />
            <Route
              path="/interior-designer-dashboard"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <InteriorDesignerDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/phases"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <Phases />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/phases/:projectId/:phaseId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <InteriorDesignerPhaseDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/phases/:projectId/configs/:configId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <InteriorDesignerConfigDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/leads"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <Leads />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/leads/:leadId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <LeadRequestDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/designs"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <Designs />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/settings"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <InteriorDesignerSettings />
                </PrivateRoute>
              }
            />
            {/* Legacy /interior-designer/profile — redirect to /settings#profile
                so old deep links and bookmarks still land users on their account. */}
            <Route
              path="/interior-designer/profile"
              element={<Navigate to="/interior-designer/settings#profile" replace />}
            />
            <Route
              path="/interior-designer/add-portfolio"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <AddPortfolio />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/edit-portfolio/:portfolioId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <AddPortfolio />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-designer/add-portfolio/:portfolioId/boq"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "INTERIOR_DESIGNER"]}>
                  <AddPortfolioBoq />
                </PrivateRoute>
              }
            />
            {/* BV_USER routes - pointing to same components as interior-designer */}
            <Route
              path="/bv-user/phases"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  <BVPhaseList />
                </PrivateRoute>
              }
            />
            {/* configs before :phaseId so "configs" is not captured as a phase id */}
            <Route
              path="/bv-user/phases/:projectId/configs/:configId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  {/* eslint-disable-next-line react/jsx-pascal-case */}
                  <BV_ConfigDetails />
                </PrivateRoute>
              }
            />
            {/* Same /bv-user/phases prefix as the list — avoids /bv-user/phase/... 404 → Unauthorized */}
            <Route
              path="/bv-user/phases/:phaseId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  {/* eslint-disable-next-line react/jsx-pascal-case */}
                  <BV_PhaseDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/bv-user/buyers"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  <Buyers />
                </PrivateRoute>
              }
            />
            <Route
              path="/bv-user/buyer/:buyerId/details"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  <BuyerDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-execution"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER", "ZUMALE_USER"]}>
                  <ExecutionUnits />
                </PrivateRoute>
              }
            />
            <Route
              path="/interior-execution/:leadId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER", "ZUMALE_USER"]}>
                  <ExecutionUnitDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/bv-user/buyer/:buyerId/requests/:interiorDesignerId"
              element={
                <PrivateRoute allowedRoles={["ADMIN", "DEVELOPER", "BV_USER"]}>
                  <RequestDetails />
                </PrivateRoute>
              }
            />

            <Route path="*" element={<Unauthorized />} />
          </Routes>
         </div>

        </div>

        {/* Footer lives INSIDE the flex column so flex-grow on the content
            area pushes it to the bottom of the viewport. The previous layout
            placed it in a sibling div with pt-80, which produced ~320px of
            dead space above the footer on tall screens. */}
        {!isLoginOrRegisterPage && <Footer />}
      </div>
    </>
  );
}

export default App;